export enum LlmModelType {
  GPT_5_2 = "gpt-5.2",
  GPT_5_MINI = "gpt-5-mini",
  GPT_5_NANO = "gpt-5-nano",
  GPT_6_LUNA_FAST = "gpt-6-luna-fast",
  GPT_REALTIME = "gpt-realtime",
  GPT_REALTIME_MINI = "gpt-realtime-mini",
  GEMINI_25_FLASH = "gemini-2.5-flash",
  GEMINI_38_FLASH = "gemini-3.8-flash",
  GEMINI_LIVE = "gemini-live",
  GEMMA_4_31B = "gemma-4-31b",
}

export const LATEST_LLM_MODEL = LlmModelType.GEMINI_38_FLASH;
